import genActTypes from '../core/types';

const types = genActTypes('visitors');

export default types;
